document.addEventListener('DOMContentLoaded', function () {
  // Select all cross-selling product containers
  const crossselling = document.querySelectorAll('.crossselling-product');

  // Function to calculate and update total price
  function updateTotalPrice() {
    console.log('Update price');
    let totalPrice = parseFloat(document.querySelector('#default-price').dataset.exclPrice); // Base price from the main product
    let totalComparePrice = document.querySelector('#default-compare-price'); // Base price from the main product
    if (totalComparePrice) {
      totalComparePrice = parseFloat(document.querySelector('#default-compare-price').dataset.exclPrice); // Base price from the main product
    }
    const vatPercentage = 21;
    console.log('totalPrice', totalPrice);

    // Add prices of selected cross-sell products
    crossselling.forEach(function (product, index) {
      console.log('product', product);
      const checkbox = product.querySelector(`input#check-${index + 1}`);
      const quantityInput = product.querySelector(`input[type="number"]`);

      console.log('checkbox', checkbox);
      if (checkbox && checkbox.checked) {
        const crossSellPrice = parseFloat(product.querySelector('[data-excl-price]').dataset.exclPrice);
        const quantity = parseInt(quantityInput.value);
        totalPrice += crossSellPrice * quantity;
        if (totalComparePrice) {
          totalComparePrice += crossSellPrice * quantity;
        }
        console.log('crossSellPrice', crossSellPrice);
      }
    });

    // Convert to VAT-inclusive price if needed (adapt depending on your toggle logic)
    const includeVAT = sessionStorage.getItem('pricesIncludeVat') === 'true';
    const finalPrice = includeVAT ? totalPrice * (1 + vatPercentage / 100) : totalPrice;
    const finalComparePrice = includeVAT ? totalComparePrice * (1 + vatPercentage / 100) : totalComparePrice;

    // Update the displayed total price
    document.querySelector('#total-price').innerHTML = `€${(finalPrice / 100).toFixed(2).replace('.', ',')}`;
    // document.querySelector('#total-price').setAttribute('data-excl-price', finalPrice);

    if (totalComparePrice) {
      // Update the displayed total compare price
      document.querySelector('#total-compare-price').innerHTML = `€${(finalComparePrice / 100).toFixed(2).replace('.', ',')}`;
      document.querySelector('#total-compare-price').setAttribute('data-excl-price', finalComparePrice);
    }
  }

  // Set up the event listeners for each cross-sell product
  crossselling.forEach(function (product, index) {
    const label = product.querySelector(`label[for="check-${index + 1}"]`);
    const activeInput = product.querySelector(`input#check-${index + 1}`);

    // Toggle the checkbox and recalculate the price when clicked
    label.addEventListener('click', function () {
      activeInput.classList.toggle('active');
      updateTotalPrice(); // Update total price after toggling
    });

    // Plus and minus buttons to control the quantity
    const plusButton = product.querySelector('.plus');
    const minusButton = product.querySelector('.min');
    const quantityInput = product.querySelector(`input[type="number"]`);

    // Event listener for the plus button
    plusButton.addEventListener('click', function () {
      let currentValue = parseInt(quantityInput.value);
      quantityInput.value = currentValue + 1;
      updateTotalPrice(); // Update total price after quantity change
    });

    // Event listener for the minus button
    minusButton.addEventListener('click', function () {
      let currentValue = parseInt(quantityInput.value);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
        updateTotalPrice(); // Update total price after quantity change
      }
    });
  });

  // Initially update the total price on page load
  updateTotalPrice();
});
